<template>
    <AppModal :show-modal="openModal" @close="handleClose" :lock-close-modal="true" :overlay="0.97" :use-min-height="useMinHeight">
        <div>
            <div class="modal-content" v-if="!showSlotContent">
                <h2 class="text-2xl font-bold mb-6 text-center">Loan Payment Information</h2>

                <div class="text-left mb-6 font-semibold text-gray-600">
                    <p>Before signing your loan agreement, please choose how your loan payments will be collected. By selecting an option below, you authorize us to collect your scheduled loan payments using that method, and your selection will become part of your loan agreement.</p>
                </div>
                <form>
                    <div class="mb-6">
                        <label class="input-label flex items-center cursor-pointer mb-4 w-full text-left border p-[30px] rounded-[10px] border-solid border-[#e7e7e7]">
                            <input
                                type="radio"
                                name="paymentType"
                                value="electronic_fund_transfer"
                                v-model="selectedType"
                                class="mt-1 mr-3"
                            />
                            <div class="w-full text-left">
                                <span class="font-semibold">Electronic fund transfer (ACH debit)</span>
                                <div class="text-sm text-gray-600 mt-1">
                                    If you select this option, your loan payment will be processed via ACH debit from your bank account.
                                </div>
                            </div>
                        </label>
                        <label class="input-label flex items-center cursor-pointer w-full text-left border p-[30px] rounded-[10px] border-solid border-[#e7e7e7]">
                            <input
                                type="radio"
                                name="paymentType"
                                value="remotely_created_check"
                                v-model="selectedType"
                                class="mt-1 mr-3"
                            />
                            <div class="w-full text-left">
                                <span class="font-semibold">Remotely Created Checks (RCCs)</span>
                                <div class="text-sm text-gray-600 mt-1">
                                    If you select this option, your loan payment will be processed using a remotely created check (RCC).
                                </div>
                            </div>
                        </label>
                    </div>
                    <div class="flex justify-center items-center mt-8 save-payment-type-container">
                        <AppButton
                            :loading="loading"
                            :disabled="!selectedType || loading"
                            @click="submitSelection"
                            btnStyle="solid"
                        >
                            Save
                        </AppButton>
                    </div>
                </form>
                <div v-if="errorMessage" class="text-red-500 text-center mt-4">{{ errorMessage }}</div>
            </div>

            <div v-else class="slot-content">
                <slot />
            </div>
        </div>
    </AppModal>
</template>

<script>
import AppModal from "./AppModal";
import AppButton from "./AppButton";
import axios from "axios";

export default {
    name: "LoanPaymentInformationModal",
    components: {
        AppModal,
        AppButton,
    },
    props: {
        loan: {
            type: Object,
            required: true,
        },
        showSlotContent: {
            type: Boolean,
            default: false,
        },
        useMinHeight: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            openModal: true,
            selectedType: "",
            loading: false,
            errorMessage: "",
        };
    },
    methods: {
        handleClose() {
            // this.$emit("close");
        },
        async submitSelection() {
            
            if (!this.selectedType) return;
            this.loading = true;
            this.errorMessage = "";
            try {
                await axios.post(`/account/loans/${this.loan.id}/set-payment-type`, {
                    payment_type: this.selectedType,
                });
                // this.openModal = false;
                this.$emit("selected", this.selectedType);
            } catch (error) {
                console.log(error.response);
                this.errorMessage =
                    error.response?.data?.message ||
                    "Failed to save payment type. Please try again.";
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
input[type="radio"] {
    accent-color: #2563eb;
}
.input-label {
    background: #f5f5f5;
}
</style>
